// extracted by mini-css-extract-plugin
module.exports = {"Login":"Login_Login__1ujut","message":"Login_message__31OzW"};